import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import * as $ from "jquery";
import { ConnectionService } from 'src/app/services/connection.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';
declare var jQuery: any;

@Component({
  selector: 'app-ecs-checkout',
  templateUrl: './ecs-checkout.component.html',
  styleUrls: ['./ecs-checkout.component.scss'],
})
export class EcsCheckoutComponent implements OnInit {

  userObj: any;
  hashReqObj: any;
  reqHashPipe: any;
  genTxnId: any;
  ecsMaxAmount: any;
  genConsumerId: any;
  // SALT: any = "9971811707IDSMCB";

  ecsBankList: any = [];

  reqConstants : any = {
    merchantId: "T586798",
    deviceId: "WEBSH2",
    // returnUrl: "https://www.tekprocess.co.in/MerchantIntegrationClient/MerchantResponsePage.jsp",
    // returnUrl: "http://mwjins.mwjit.com/user/public/callback/ecs/response",
    returnUrl: "http://mwjins.mwjit.com/user/public/callbackurlecs",
    paymentMode: "netBanking",
    merchantLogoUrl: "https://www.mypolicyjunction.com/assets/img/new/HOME%20SCREEN/logo.png",
    currency: "INR",
    amountType: "F",
    totalamount: "5",
    // itemId: "Test"
  }

  quoteDetails: any;
  ecsBankCodeId: any;

  ecsBankDetailsForm: FormGroup;

  reqExtData = {
    debitStartDate: "",
    debitEndDate: "",
    maxAmount: "",
    frequency: "",
    bankCode: "",
    accountHolderName: "",
    accountNo: "",
    ifscCode: "",
    accountType: "",
  }

  ecsHashToken: any;

  constructor(
    private iab: InAppBrowser,
    private strg: StorageService,
    private _datePipe: DatePipe,
    private apiService: ConnectionService,
    private router: Router,
    // private _dataFields: DataFieldsService,
    private toast: ToastService,
    private fb: FormBuilder,
  ) { 
    $('head').append('<script async type="text/javascript" src="https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js"></script>');
    $('head').append('<script async type="text/javascript" src="https://www.paynimo.com/paynimocheckout/server/lib/checkout.js"></script>');

    this.strg.getStoreData("userObj").then(res=>{
      this.userObj = res;
      this.genTxnId = (Math.random().toString(36).slice(2)).substring(0,10).toUpperCase();
      this.genConsumerId = "MPJ"+this.userObj.id+this.genTxnId;
    });
    
    this.strg.getStoreData("ecsDlts").then(res=>{
      this.quoteDetails = res;
    });
  }
  
  ngOnInit() {
    let type = "Net Banking" // Debit card , all , Net Banking
    this.apiService.getEcsBankList(type).subscribe(res => {
      if(res.status === "OK") {
        this.ecsBankList = res.data;
      }
    });

    this.ecsBankDetailsForm = this.fb.group({
      "bank": ["", [Validators.required]],
      "accHolderName": ["", [Validators.required]],
      "accountNo": ["", [Validators.required]],
      "ifsc": ["", [Validators.required]],
      "accountType": ["", [Validators.required]],
    });

    this.ecsBankDetailsForm.valueChanges.subscribe(res=> {
      this.reqExtData.bankCode = this.ecsBankDetailsForm.get("bank").value;
      this.reqExtData.accountHolderName = this.ecsBankDetailsForm.get("accHolderName").value;
      this.reqExtData.accountNo = this.ecsBankDetailsForm.get("accountNo").value;
      this.reqExtData.ifscCode = this.ecsBankDetailsForm.get("ifsc").value;
      this.reqExtData.accountType = this.ecsBankDetailsForm.get("accountType").value;
      let bank = this.ecsBankList.filter(item => item.code === this.reqExtData.bankCode);
      this.ecsBankCodeId = bank[0].id;
    });

    setTimeout(()=>{
      this.getPolicyQuoteDetails();
    },500);
  
  }

  getPolicyQuoteDetails(){
    //products to be handled
    let today = new Date();
    this.reqExtData.debitStartDate = this._datePipe.transform(today, "dd-MM-yyyy");
    let ppt = this.quoteDetails.responseObj.premiumPaymentTerm;
    this.reqExtData.debitEndDate = this._datePipe.transform(new Date(today.setFullYear(today.getFullYear() + Number(ppt))), "dd-MM-yyyy");
    let ecsFreqc = this.quoteDetails.responseObj.modeOfPayment;
    if(ecsFreqc === "Yearly") {
      this.reqExtData.frequency = "YEAR"
    } else if(ecsFreqc === "Half-Yearly"){
      this.reqExtData.frequency = "MIAN"
    } else if(ecsFreqc === "Monthly"){
      this.reqExtData.frequency = "MNTH"
    }
    this.reqExtData.maxAmount = this.quoteDetails.responseObj.premiumInstallmentWithTax;
  }

  postEcsData(){
    this.hashReqObj = {
      merchantId : this.reqConstants.merchantId,
      txnId: this.genTxnId,
      totalamount: this.reqConstants.totalamount,
      accountNo: this.reqExtData.accountNo,
      consumerId: this.genConsumerId,
      consumerMobileNo: this.userObj.phoneNumber,
      consumerEmailId: this.userObj.email,
      debitStartDate: this.reqExtData.debitStartDate,
      debitEndDate: this.reqExtData.debitEndDate,
      // maxAmount: this.reqExtData.maxAmount,
      maxAmount: 2,
      amountType: this.reqConstants.amountType,
      frequency: this.reqExtData.frequency,
      cardNumber: "",
      expMonth: "",
      expYear: "",
      cvvCode: "",
      accountHolderName: this.reqExtData.accountHolderName,
      ifscCode: this.reqExtData.ifscCode,
      accountType: this.reqExtData.accountType,
      paymentMode: this.reqConstants.paymentMode,
      emandateBank: this.ecsBankCodeId,
    }
    this.reqHashPipe = `${this.hashReqObj.merchantId}|${this.hashReqObj.txnId}|${this.hashReqObj.totalamount}|${this.hashReqObj.accountNo}|${this.hashReqObj.consumerId}|${this.hashReqObj.consumerMobileNo}|${this.hashReqObj.consumerEmailId}|${this.hashReqObj.debitStartDate}|${this.hashReqObj.debitEndDate}|${this.hashReqObj.maxAmount}|${this.hashReqObj.amountType}|${this.hashReqObj.frequency}|${this.hashReqObj.cardNumber}|${this.hashReqObj.expMonth}|${this.hashReqObj.expYear}|${this.hashReqObj.cvvCode}`;
    this.hashReqObj.hashPipeString = this.reqHashPipe;
    
    this.apiService.getEcsHash(this.hashReqObj).subscribe(res => {
      if(res.status == "OK"){
        this.ecsHashToken = res.data
        this.callCheckoutJs();
      }
    });

  }

  // ngAfterViewInit() {
  //   // $('head').append('<script async type="text/javascript" src="https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js"></script>');
  //   // $('head').append('<script async type="text/javascript" src="https://www.paynimo.com/paynimocheckout/server/lib/checkout.js"></script>');
  //   $(document).ready(function() {
  //     function handleResponse(res) {
  //         if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0300') {
  //             // success block
  //         } else if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0398') {
  //             // initiated block
  //         } else {
  //             // error block
  //         }
  //     };
  
  //     $(document).off('click', '#btnSubmit').on('click', '#btnSubmit', function(e) {
  //         e.preventDefault();
  //         // alert('JQuery is working!!');
  //         var configJson = {
  //             'tarCall': false,
  //             'features': {
  //                 'showPGResponseMsg': true,
  //                 'enableAbortResponse': true,
  //                 'enableNewWindowFlow': false,    //for hybrid applications please disable this by passing false
  //                 'enableExpressPay':true,
  //                 'siDetailsAtMerchantEnd':true,
  //                 'enableSI':true
  //             },
  //             'consumerData': {
  //                 'deviceId': this.reqConstants.deviceId,	//possible values 'WEBSH1' and 'WEBSH2'
  //                 // 'token': 'd614d98f4ebc55ce55ed1003f6b3b0fa5dbb146b1e74b3aa411fdb8eecfe7ef64d151520a860ddefe627113480d6f46a29c389ddca4f2b65b81942b7321d77ad',
  //                 'token': this.ecsHashToken,
  //                 'returnUrl': this.reqConstants.returnUrl,    //merchant response page URL
  //                 'responseHandler': handleResponse,
  //                 'paymentMode': this.reqConstants.paymentMode,
  //                 'merchantLogoUrl': this.reqConstants.merchantLogoUrl,  //provided merchant logo will be displayed
  //                 'merchantId': this.hashReqObj.merchantId,
  //                 'currency': this.reqConstants.currency,
  //                 'consumerId': this.hashReqObj.consumerId,  //Your unique consumer identifier to register a eMandate/eNACH
  //                 'consumerMobileNo': this.hashReqObj.consumerMobileNo,
  //                 'consumerEmailId': this.hashReqObj.consumerEmailId,
  //                 'txnId': this.hashReqObj.txnId,   //Unique merchant transaction ID
  //                 'items': [{
  //                     'itemId': 'test',
  //                     'amount': this.reqConstants.totalamount,
  //                     'comAmt': '0'
  //                 }],
  //                 'customStyle': {
  //                     'PRIMARY_COLOR_CODE': '#3977b7',   //merchant primary color code
  //                     'SECONDARY_COLOR_CODE': '#FFFFFF',   //provide merchant's suitable color code
  //                     'BUTTON_COLOR_CODE_1': '#1969bb',   //merchant's button background color code
  //                     'BUTTON_COLOR_CODE_2': '#FFFFFF'   //provide merchant's suitable color code for button text
  //                 },
  //                 'accountNo': this.reqExtData.accountNo,    //Pass this if accountNo is captured at merchant side for eMandate/eNACH
  //                 'accountHolderName': this.reqExtData.accountHolderName,  //Pass this if accountHolderName is captured at merchant side for ICICI eMandate & eNACH registration this is mandatory field, if not passed from merchant Customer need to enter in Checkout UI.
  //                 'ifscCode': this.reqExtData.ifscCode,        //Pass this if ifscCode is captured at merchant side.
  //                 'bankCode': this.reqExtData.bankCode,
  //                 'accountType': this.reqExtData.accountType,  //Required for eNACH registration this is mandatory field - Saving : Saving, Current : Current
  //                 'debitStartDate': this.hashReqObj.debitStartDate,
  //                 'debitEndDate': this.hashReqObj.debitEndDate,
  //                 'maxAmount': this.hashReqObj.maxAmount,
  //                 'amountType': this.reqConstants.amountType, //M : Variable Amount, F : Fixed Amount
  //                 'frequency': this.hashReqObj.frequency	// DAIL : Daily, WEEK : Weekly, MNTH : Monthly, QURT : Quarterly, MIAN : Semi annually, YEAR : Yearly, BIMN : Bi- monthly, ADHO : As and when presented
  //             }
  //         };
  
  //         jQuery.pnCheckout(configJson);
  //         // if(configJson.features.enableNewWindowFlow){
  //         //   pnCheckoutShared.openNewWindow();
  //         // }
  //     });
  //   });
  // }

  callCheckoutJs(){
    // $(document).ready(function() {
      function handleResponse(res) {
          if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0300') {
              // success block
          } else if (typeof res != 'undefined' && typeof res.paymentMethod != 'undefined' && typeof res.paymentMethod.paymentTransaction != 'undefined' && typeof res.paymentMethod.paymentTransaction.statusCode != 'undefined' && res.paymentMethod.paymentTransaction.statusCode == '0398') {
              // initiated block
          } else {
              // error block
          }
      };
  
      // $(document).off('click', '#btnSubmit').on('click', '#btnSubmit', function(e) {
      //     e.preventDefault();
          // alert('JQuery is working!!');
          var configJson = {
              'tarCall': false,
              'features': {
                  'showPGResponseMsg': true,
                  'enableAbortResponse': true,
                  'enableNewWindowFlow': false,    //for hybrid applications please disable this by passing false
                  'enableExpressPay':true,
                  'siDetailsAtMerchantEnd':true,
                  'enableSI':true
              },
              'consumerData': {
                  'deviceId': this.reqConstants.deviceId,	//possible values 'WEBSH1' and 'WEBSH2'
                  'token': this.ecsHashToken,
                  'returnUrl': this.reqConstants.returnUrl,    //merchant response page URL
                  'responseHandler': handleResponse,
                  'paymentMode': this.reqConstants.paymentMode,
                  'merchantLogoUrl': this.reqConstants.merchantLogoUrl,  //provided merchant logo will be displayed
                  'merchantId': this.reqConstants.merchantId,
                  'currency': this.reqConstants.currency,
                  'consumerId': this.hashReqObj.consumerId,  //Your unique consumer identifier to register a eMandate/eNACH
                  'consumerMobileNo': this.hashReqObj.consumerMobileNo,
                  'consumerEmailId': this.hashReqObj.consumerEmailId,
                  'txnId': this.hashReqObj.txnId,   //Unique merchant transaction ID
                  'items': [{
                      'itemId': 'First',
                      'amount': this.reqConstants.totalamount,
                      'comAmt': '0'
                  }],
                  'customStyle': {
                      'PRIMARY_COLOR_CODE': '#3977b7',   //merchant primary color code
                      'SECONDARY_COLOR_CODE': '#FFFFFF',   //provide merchant's suitable color code
                      'BUTTON_COLOR_CODE_1': '#1969bb',   //merchant's button background color code
                      'BUTTON_COLOR_CODE_2': '#FFFFFF'   //provide merchant's suitable color code for button text
                  },
                  'accountNo': this.reqExtData.accountNo,    //Pass this if accountNo is captured at merchant side for eMandate/eNACH
                  'accountHolderName': this.reqExtData.accountHolderName,  //Pass this if accountHolderName is captured at merchant side for ICICI eMandate & eNACH registration this is mandatory field, if not passed from merchant Customer need to enter in Checkout UI.
                  'ifscCode': this.reqExtData.ifscCode,        //Pass this if ifscCode is captured at merchant side.
                  'bankCode': this.reqExtData.bankCode,
                  'accountType': this.reqExtData.accountType,  //Required for eNACH registration this is mandatory field - Saving : Saving, Current : Current
                  'debitStartDate': this.hashReqObj.debitStartDate,
                  'debitEndDate': this.hashReqObj.debitEndDate,
                  'maxAmount': this.hashReqObj.maxAmount,
                  'amountType': this.reqConstants.amountType, //M : Variable Amount, F : Fixed Amount
                  'frequency': this.hashReqObj.frequency	// DAIL : Daily, WEEK : Weekly, MNTH : Monthly, QURT : Quarterly, MIAN : Semi annually, YEAR : Yearly, BIMN : Bi- monthly, ADHO : As and when presented
              }
          };
  
          jQuery.pnCheckout(configJson);

          // if(configJson.features.enableNewWindowFlow){
          //   pnCheckoutShared.openNewWindow();
          // }
      // });
    // });
  }

  validateLettersOnly(event) {
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }
}
